module.exports = __webpack_public_path__ + "static/media/intro.4424e474.mp3";